import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ROOMS_PATH, routeTo } from "@/lib/site";
import { MaskReveal, Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

export function AboutAccommodations() {
  const photo = PHOTOS.rvSite;

  return (
    <section
      className="bg-background py-24 sm:py-28 lg:py-32"
      aria-labelledby="accommodations-title"
    >
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-4 sm:px-6 lg:grid-cols-[1.15fr_1fr] lg:gap-20 lg:px-10">
        <MaskReveal className="media-zoom rounded-sm lg:order-2">
          <img
            src={photo.src}
            srcSet={photo.srcSet}
            sizes={PHOTO_SIZES.half}
            alt={photo.alt}
            width={photo.width}
            height={photo.height}
            loading="lazy"
            decoding="async"
            className="aspect-[16/11] w-full rounded-sm object-cover lg:aspect-[5/4]"
          />
        </MaskReveal>

        <div className="lg:order-1">
          <Reveal>
            <p className="eyebrow text-clay">Room to Make Yourself Comfortable</p>
            <h2
              id="accommodations-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              Accommodations for Short Visits and Extended Stays
            </h2>
          </Reveal>

          <Reveal
            delay={0.08}
            className="mt-6 space-y-5 text-base leading-relaxed text-muted-foreground sm:text-lg"
          >
            <p>
              Amigo Inn &amp; RV Park offers 65 RV sites with pull-through and back-in options.
              Sites are available with 30- or 50-amp electrical service, and full-hookup sites
              include water, sewer, electric service, cable television, and Wi-Fi.
            </p>
            <p>
              For guests traveling without an RV, the property also offers motel rooms and
              efficiency-style accommodations. These furnished options include practical
              conveniences such as a stove, refrigerator, microwave, and select kitchen essentials.
            </p>
            <p>
              Whether guests are visiting for a weekend or staying for an entire season, Amigo Inn
              provides flexible accommodations designed to make their time in Zapata more
              comfortable.
            </p>
          </Reveal>

          <Reveal delay={0.14} className="mt-10">
            <Button asChild variant="forest" size="cta">
              <Link to={routeTo(ROOMS_PATH)}>
                View Sites &amp; Rooms <ArrowRight aria-hidden="true" />
              </Link>
            </Button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
